import { hasAccount } from 'app/common/lib/accounts';
import { State } from 'app/gamma/src/modules/types';
import { getMe } from './members';
import { getMyTeams } from './teams';

import { TeamModel } from 'app/gamma/src/types/models';

export const hasMemberAccount = (state: State) => {
  const me = getMe(state);

  return hasAccount(me && me.paidAccount && me.paidAccount.standing);
};

export const hasOrgAccount = (state: State) => {
  const teams = getMyTeams(state);

  return !!teams.some((org: TeamModel) => {
    return hasAccount(org.paidAccount && org.paidAccount.standing);
  });
};

export const hasMemberOrOrgAccount = (state: State) => {
  return hasMemberAccount(state) || hasOrgAccount(state);
};
